
export const avg = ( arr: number[] ): number => arr.reduce( ( a, b ) => a + b, 0 ) / arr.length;
export const sum = ( arr: number[] ): number => arr.reduce( ( a, b ) => a + b, 0 );

export function linearInterpolate( ia: number, ib: number, oa: number, ob: number, value: number ): number {
    const t = Math.max( 0, Math.min( 1, ( value - ia ) / ( ib - ia ) ) );
    return oa + t * ( ob - oa );
}

export function quantize( step: number, value: number ) {
    return Math.round( value * ( 1 / step ) ) * step;
}